import React from "react";
import ChangementMotDePasseComponent from "@/components/ChangementMotDePasse/ChangementMotDePasseComponent";
import { MDP_DATA } from "@/constants/data";
const ChangePasswordPage: React.FC = () => {
  const customMDPData = {
    ...MDP_DATA,
    titre: "Réinitialisation de votre mot de passe",
    sousTitre: "Choisissez un nouveau mot de passe sécurisé",
  };
  return (
    <div>
      <div className="text-center mt-40">
        <p className="text-lg italic text-[#000080]">
          Un nouveau départ en toute sécurité !{" "}
        </p>
        <p className="text-xl font-bold text-gray-900 mt-1">
          Sécurisez votre compte en un instant
        </p>
      </div>

      <ChangementMotDePasseComponent
        mode="reinitialisation"
        titre={customMDPData.titre}
        sousTitre={customMDPData.sousTitre}
        description={customMDPData.description}
        image={customMDPData.image}
      />
    </div>
  );
};

export default ChangePasswordPage;
